import { render, staticRenderFns } from "./use-personal-data.vue?vue&type=template&id=2042810a&scoped=true&"
import script from "./use-personal-data.vue?vue&type=script&lang=js&"
export * from "./use-personal-data.vue?vue&type=script&lang=js&"
import style0 from "./use-personal-data.vue?vue&type=style&index=0&id=2042810a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042810a",
  null
  
)

export default component.exports